<div class="mat-typography mismatch-dialog">
  <div class="import-dialog">
    <div class="import-dialog__header">
      <span class="import-dialog__title">
        Column mismatch detected
      </span>
    </div>

    <div class="horizontal-separator"></div>

    <div class="import-dialog__info-message">
      <p>Some columns in this file differ from others. Please review before continuing.</p>
    </div>

    <div class="import-dialog__mismatch-container">
      @if (missingColumnsList?.length) {
        <div class="import-dialog__mismatch-log">
          <div class="mismatch-log-title">
            <span>
              Missing columns ({{ missingColumnsList.length }})
            </span>
            <div class="icon icon-info" [matTooltip]="'Present in other files, but not in this one'"></div>
          </div>
          <div class="horizontal-separator internal"></div>
          <ul class="mismatch-log-field-list">
            @for (field of missingColumnsList; track field) {
              <li class="mismatch-log-field-list-item">
                • {{ field }}
              </li>
            }
          </ul>
        </div>
      }

      @if (extraColumnsList?.length) {
        <div class="import-dialog__mismatch-log">
          <div class="mismatch-log-title">
            <span>
              Extra columns ({{ extraColumnsList.length }})
            </span>
            <div class="icon icon-info" [matTooltip]="'Present in this files, but not in other'"></div>
          </div>
          <div class="horizontal-separator internal"></div>
          <ul class="mismatch-log-field-list">
            @for (field of extraColumnsList; track field) {
              <li class="mismatch-log-field-list-item">
                • {{ field }}
              </li>
            }
          </ul>
        </div>
      }
    </div>

  </div>

  <div class="import-dialog__footer">
    <div class="import-dialog__actions">
      <button type="button" class="cancel-button" (click)="close()">Close</button>
      <button mat-raised-button color="primary" type="button" class="frmg-primary-button" (click)="confirmUpload()">
        Confirm and Continue
      </button>
    </div>
  </div>
</div>
